import dburl from '../utils/dburl';

export default function getBlogCards() {
  const url = dburl+"blog"

  return fetch(url)
  .then(res => res.json())   
  .catch(err => {
    console.log(err)
    return {status:404}
  })
}